// removed by extract-text-webpack-plugin
module.exports = {"container":"g7XOSBnQqjznR_kR6Vw9O","error":"_1AfRpqdsWFW7a7kMrpA7dd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/FormErrors.mod.css
// module id = 1076
// module chunks = 0